<div class="fr-root" [attr.dir]="dir" [ngStyle]="brandVars" [class.bb-desktop]="isDesktop"
     [class.bb-over-hero]="isDesktop && (screen$ | async) === 'home'"
     [class.bb-has-announce]="isDesktop && !config.storeOff && announcements.length > 0"
     [class.bb-doc-scroll]="docScroll"
     [class.bb-has-tabs]="docScroll && showTabs((screen$ | async) || '')"
     [class.bb-has-cartbar]="docScroll && showCartBar((screen$ | async) || '') && !!(count$ | async)">

  <!-- Brand not found: no restaurant at this address — replaces the whole storefront (Sonic-neutral, no brand data). -->
  <div *ngIf="config.brandNotFound" class="bb-maint bb-notfound">
    <div class="bb-maint-stripes"></div>
    <div class="bb-maint-inner">
      <div style="flex:1"></div>

      <span class="bb-maint-badge"><app-icon name="solar:shop-2-bold" [size]="30" color="#fff"></app-icon></span>
      <span class="bb-maint-pill"><span class="bb-maint-dot"></span> {{ 'Store not found' | t }}</span>
      <h1 class="bb-maint-title">{{ 'We couldn’t find this restaurant' | t }}</h1>
      <p class="bb-maint-msg">
        {{ 'There’s no restaurant at' | t }} <b class="fr-ltr" style="color:#fff">{{ host }}</b>.
        {{ 'Check the address, or ask the restaurant for their ordering link.' | t }}
      </p>

      <div style="flex:1"></div>

      <button class="bb-maint-retry" (click)="retry()"><app-icon name="solar:refresh-bold" [size]="18" color="var(--brand-deep)"></app-icon> {{ 'Try again' | t }}</button>
      <a class="bb-notfound-pow" href="https://www.sonic-pos.com/" target="_blank" rel="noopener">
        {{ 'Powered by' | t }} <img src="assets/sonic.png" alt="Sonic" onerror="this.style.display='none'">
      </a>
    </div>
  </div>

  <!-- Maintenance: replaces the whole storefront when the operator enables it.
       Fully brand-themed (colors/logo/name/hotline/socials from /api/v1/brand). -->
  <div *ngIf="config.maintenance" class="bb-maint">
    <div class="bb-maint-stripes"></div>
    <div class="bb-maint-inner">
      <!-- brand header -->
      <div class="bb-maint-head">
        <span class="bb-maint-logo"><img *ngIf="config.brandLogo" [src]="config.brandLogo" alt="" onerror="this.style.display='none'"></span>
        <div style="min-width:0">
          <div class="bb-maint-name">{{ config.brandName }}</div>
          <div *ngIf="config.faviconOrigin" class="bb-maint-domain">{{ config.faviconOrigin }}</div>
        </div>
      </div>

      <div style="flex:1"></div>

      <!-- badge icon -->
      <span class="bb-maint-badge"><app-icon name="solar:settings-bold" [size]="30" color="#fff"></app-icon></span>

      <span class="bb-maint-pill"><span class="bb-maint-dot"></span> {{ 'Ordering paused' | t }}</span>
      <h1 class="bb-maint-title">{{ 'We’re taking a short break' | t }}</h1>
      <p class="bb-maint-msg">{{ config.maintenanceMessage || ('Online ordering is paused while we make some updates. We’ll be back very shortly — thanks for your patience.' | t) }}</p>

      <div style="flex:1"></div>

      <!-- actions -->
      <button class="bb-maint-retry" (click)="retry()"><app-icon name="solar:refresh-bold" [size]="18" color="var(--brand-deep)"></app-icon> {{ 'Try again' | t }}</button>
      <div class="bb-maint-sub">{{ 'Still down? We’ll be back as soon as we can.' | t }}</div>
      <a *ngIf="config.brandHotline" [href]="'tel:' + config.brandHotline" class="bb-maint-call">
        <app-icon name="solar:phone-bold" [size]="18" color="#fff"></app-icon>
        {{ 'Call to order' | t }} · <span class="fr-num">{{ config.brandHotline }}</span>
      </a>

      <div *ngIf="config.social.length" class="bb-maint-social">
        <a *ngFor="let s of config.social" [href]="s.url" target="_blank" rel="noopener"><app-icon [name]="s.icon" [size]="19" color="#fff"></app-icon></a>
      </div>
    </div>
  </div>

  <!-- Desktop: announcement bar across the very top, above the header -->
  <div *ngIf="isDesktop && !config.storeOff && announcements.length" class="bb-announce-top">
    <app-announcement-marquee [messages]="announcements" class="bb-announce-row"></app-announcement-marquee>
  </div>

  <!-- Desktop: sticky top bar (brand, nav, order type, search, account, cart) -->
  <app-desktop-header
    *ngIf="isDesktop && !config.storeOff"
    [active]="(screen$ | async) || 'home'"
    [lang]="lang"
    [homeOn]="homeOn"
    [dark]="isDesktop && (screen$ | async) === 'home' && pageAtTop"
    (nav)="nav($event)"
    (cart)="goCart()"
    (langToggle)="toggleLang()">
  </app-desktop-header>

  <div class="bb-viewport">
    <!-- Phones: each screen scrolls itself inside this frame.
         Desktop: this container scrolls the page (screen + footer). -->
    <div class="bb-page" #page appAutoReveal (scroll)="onPageScroll()">
      <router-outlet *ngIf="!reloading && !config.storeOff"></router-outlet>
      <app-desktop-footer *ngIf="isDesktop && !config.storeOff"></app-desktop-footer>
    </div>

    <app-cart-bar
      *ngIf="!isDesktop && showCartBar((screen$ | async) || '')"
      [count]="(count$ | async) || 0"
      [total]="(total$ | async) || 0"
      (open)="goCart()">
    </app-cart-bar>

    <!-- Dine-in FAB: only when the brand supports dine-in; lifts above the cart bar.
         The desktop menu carries its own "Scan to dine in" entry in the category rail. -->
    <button
      *ngIf="showDineFab((screen$ | async) || '')"
      class="bb-dine-fab"
      [class.bb-dine-fab--raised]="showCartBar((screen$ | async) || '') && (count$ | async)"
      (click)="openDineIn()">
      <app-icon name="solar:qr-code-bold" [size]="19"></app-icon>
      {{ 'Scan to dine-in' | t }}
    </button>
  </div>

  <app-tab-bar
    *ngIf="!isDesktop && showTabs((screen$ | async) || '')"
    [active]="(screen$ | async) || 'home'"
    [homeOn]="homeOn"
    (nav)="nav($event)">
  </app-tab-bar>

  <!-- transient toast -->
  <div class="bb-toast" [class.bb-toast--error]="(toast$ | async)?.error" *ngIf="toast$ | async as toast">
    <app-icon [name]="toast.error ? 'solar:danger-triangle-bold' : 'solar:check-circle-bold'" [size]="17" [color]="toast.error ? '#ff6b6b' : 'var(--brand-300)'"></app-icon>
    {{ toast.text | t }}
  </div>

  <!-- overlays mounted by the shell -->
  <app-item-sheet></app-item-sheet>
  <!-- desktop search palette (header search button) -->
  <app-search-overlay *ngIf="isDesktop"></app-search-overlay>
  <app-login-sheet></app-login-sheet>
  <app-fulfillment-sheet></app-fulfillment-sheet>
  <app-confirm-dialog></app-confirm-dialog>
</div>
